import CancelBackButton from "components/Buttons/CancelBackButton";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import LoaderErrorWrapper from "components/LoaderErrorWrapper/LoaderErrorWrapper";
import PageContainer from "components/PageContainer/PageContainer";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchCustomerById } from "slices/Customer/thunk";

// interface SupplierDocument {
//   document_id: string;
//   document_number: string;
//   document_file: string;
//   Pan_card: boolean;
//   gst: boolean;
//   cin: boolean;
//   other: boolean;
//   KYC_approved: boolean;
//   is_verified: boolean;
// }

const CustomerDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customerDetails, setCustomerDetails] = useState<any>(null);

  const [loading, setLoading] = useState<any>(null);

  useEffect(() => {
    const fetchCustomerData = async () => {
      setLoading(true);
      try {
        if (id) {
          const resultAction = await dispatch(fetchCustomerById(id) as any);

          if (fetchCustomerById.fulfilled.match(resultAction)) {
            setCustomerDetails(resultAction.payload);
          } else {
            console.error(
              "Failed to fetch customer:",
              resultAction.payload?.message || "Unknown error"
            );
          }
        }
      } catch (error) {
        console.error("Error fetching customer:", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchCustomerData();
  }, [id, dispatch]);


  return (
    <PageContainer>
      <FormHeader
        title="Customer Details"
        firstLabel="Customer"
        secondLabel="Customer Details"
        handleArrowClick={() => navigate("/customer")}
      />
          <hr />

          {loading ? (
              <LoaderErrorWrapper loading={loading} children={undefined} />
            ) : (
            <Card.Body>
              <Row className="mb-3">
                <Col md={6}>
                  <p>
                    <strong>Customer Name :</strong>&nbsp;
                    {customerDetails?.customer_name || "—"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Cutomer Type :</strong>&nbsp;
                    {customerDetails?.customer_type || "—"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Aadhar No. :</strong>&nbsp;
                    {customerDetails?.aadhar_no || "—"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>GSTIN :</strong>&nbsp;
                    {customerDetails?.gstin || "—"}
                  </p>
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <p>
                  <h6 className="card-title mb-0 mt-3">Contact Details</h6>
                </p>

                <Col md={6}>
                  <p>
                    <strong>Email ID:</strong>&nbsp;
                    {customerDetails?.email || "—"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Phone Number:</strong>&nbsp;
                    {customerDetails?.contact_number || "—"}
                  </p>
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <p>
                  <h6 className="card-title mb-0 mt-3">
                    Contact Person Details{" "}
                  </h6>
                </p>
                <Col md={6}>
                  <p>
                    <strong>Contact Person Name :</strong>&nbsp;
                    {customerDetails?.contact_person_name || "—"}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Phone Number:</strong>&nbsp;
                    {customerDetails?.contact_person_mobile_no || "—"}
                  </p>
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <p>
                  <h6 className="card-title mb-0 mt-3">
                    Customer Address Details
                  </h6>
                </p>
                <Col md={4}>
                  <p>
                    {" "}
                    <strong>Address: </strong>&nbsp;
                    {customerDetails?.address || "—"}{" "}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    {" "}
                    <strong>City:</strong>&nbsp;
                    {customerDetails?.city || "—"}{" "}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    {" "}
                    <strong>State:</strong>&nbsp;
                    {customerDetails?.state || "—"}{" "}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    <strong>Country:</strong>&nbsp;
                    {customerDetails?.country || "—"}{" "}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    <strong>Pin Code:</strong>&nbsp;
                    {customerDetails?.pincode || "—"}{" "}
                  </p>
                </Col>
              </Row>

              <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
                {/* <Button
                  className="px-4 mb-2"
                  variant="outline-secondary"
                  style={{
                    color: "#878899",
                    borderColor: "#B0BAC9",
                    backgroundColor: "transparent",
                  }}
                  onClick={handleCancel}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Cancel
                </Button> */}
                <CancelBackButton to="/customer" label="Cancel" />
              </div>
            </Card.Body>
          )}
    </PageContainer>
  );
};

export default CustomerDetails;
